import { useMemo } from 'react'
import { useColorModeValue } from '@chakra-ui/react'

export function useCopyableCodeStyles() {
  const hoverBg = useColorModeValue('gray.100', 'whiteAlpha.200')
  const activeBg = useColorModeValue('gray.200', 'whiteAlpha.300')

  return useMemo(
    () => ({
      hover: { bg: hoverBg },
      active: { bg: activeBg },
    }),
    [activeBg, hoverBg]
  )
}
